import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import TextField from '@mui/material/TextField';
import { Button, DialogActions, FormControl, FormHelperText } from "@material-ui/core";
import { trim } from "lodash";

export default function VoidItem(props) {

  const { open, handleClose, voidItemDetails, onSubmitSuccess } = props;
  const [reason, setReason] = React.useState('');
  const [errorText, setErrorText] = React.useState('');

  const validateReason = () => {
    if (reason.length >= 1000) {
      setErrorText('Reason cannot exceed 1000 characters.');
      return;
    }
    if (trim(reason) === '') {
      setErrorText('Void reason should not be blank.');
      return;
    }
    voidItemDetails(reason);
    if (onSubmitSuccess) {
      onSubmitSuccess(reason);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth={true}
      maxWidth={'sm'}
    >
      <DialogTitle >
        Warning!
        <IconButton onClick={() => { handleClose() }} style={{ float: 'right' }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <div> This inventory item cannot be voided because it has an additional cost greater than 0. If you want to skip this, Please provide a reason.
 </div>
        <div>
          <FormControl style={{ width: '400px', margin: '20px 0px' }}>
            <TextField
              id="outlined-multiline-flexible"
              label="Enter reason to proceed"
              multiline
              maxRows={4}
              required={true}
              style={{ width: '400px !important' }}
              onChange={(e) => { setReason(e.target.value); setErrorText('') }}
            />
            <FormHelperText className="error-o">{errorText}</FormHelperText>
          </FormControl>
        </div>
      </DialogContent>

      <DialogActions>
        <Button color="primary" autoFocus onClick={handleClose}>
          Cancel
        </Button>
        <Button color="primary" onClick={validateReason}>Proceed</Button>
      </DialogActions>
    </Dialog>
  );
}
